module.exports = __webpack_public_path__ + "img/img13.c45782f9.svg";